import React, { useState, useEffect } from "react";
import TravelTourismManagementHeader from "../components/Courses/TravelTourismManagement/TravelTourismManagementHeader";
import TravelTourismManagementCareerSkills from "../components/Courses/TravelTourismManagement/TravelTourismManagementCareerSkills";
import TravelTourismManagementAdmissionRequirements from "../components/Courses/TravelTourismManagement/TravelTourismManagementAdmissionRequirements";
import ProgramDuration from "../components/Courses/Shared/ProgramDuration";
import ProgramBenefits from "../components/Courses/Shared/ProgramBenefits";
import StudentAcceptanceForm from "../components/Courses/Shared/StudentAcceptanceForm";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import cmsApi from "../services/cmsApi";

const TRAVEL_TOURISM_BENEFITS = [
  "A Booming Industry with Real Opportunities — Tanzania's tourism sector is expanding rapidly. From Kilimanjaro to Zanzibar, the demand for trained, professional tourism managers is growing every year — making this a smart and timely career choice.",
  "Diverse, Exciting Career Paths — Graduates work in hotels, airlines, travel agencies, tour operations, event management companies, government tourism boards, and international hospitality groups.",
  "Business Skills with a Human Touch — You will gain transferable skills in marketing, financial planning, customer service, and project management — all delivered in the context of a dynamic, people-first industry.",
  "Work Anywhere in the World — Tourism is a global industry. Your qualification and skills are recognized and valued across East Africa and internationally, giving you the freedom to build a career wherever opportunity takes you.",
  "Sustainability and Responsibility — Modern tourism professionals must understand sustainable development, environmental protection, and cultural preservation. Our program prepares you to be a responsible leader in the industry.",
  "Turn Your Passion into a Profession — If you love people, travel, culture, and creating memorable experiences, this program transforms that passion into a recognized, professional career.",
];

const TRAVEL_TOURISM_CAREER_PATHS =
  "Graduates commonly go on to work as Hotel Managers, Tour Operators, Travel Consultants, Destination Marketing Officers, Event Planners, and Airline Customer Service Managers.";

const TravelTourismManagement = () => {
  const [pageComponents, setPageComponents] = useState({});
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  useEffect(() => {
    // Only fetch on client side to avoid hydration issues
    if (typeof window === 'undefined') return;

    const fetchPageData = async () => {
      try {
        setLoading(true);
        
        // Fetch all page components for Travel & Tourism Management page
        const result = await cmsApi.getPageComponents('travel-tourism-management');
        
        if (result.success && result.components) {
          // Filter to only active components and organize by componentName
          const componentsMap = {};
          result.components
            .filter(comp => comp.isActive !== false) // Only show active components
            .forEach(comp => {
              componentsMap[comp.componentName] = comp;
            });
          setPageComponents(componentsMap);
        } else {
          console.warn('No page components found, using defaults');
        }
      } catch (error) {
        console.error('Error fetching Travel & Tourism Management page data:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  // Show loading state (optional)
  if (loading && typeof window !== 'undefined') {
    return (
      <div>
        <Navbar />
        <div className="mid-desktop-page">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-custom-pink border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600">Loading Travel & Tourism Management page...</p>
          </div>
        </div>
        </div>
        <Footer />
        <FloatingSocialPanels />
      </div>
    );
  }

  // Always render components - they have default content if CMS data is missing
  const headerComponent = pageComponents.header;
  const careerSkillsComponent = pageComponents['career-skills'];
  const admissionRequirementsComponent = pageComponents['admission-requirements'];

  return (
    <div>
      <Navbar />
      <div className="mid-desktop-page">
      {/* Hero Section - Always render with defaults if no CMS data */}
      <TravelTourismManagementHeader componentData={headerComponent} />
      {/* Career Skills Section - Always render with defaults if no CMS data */}
      <TravelTourismManagementCareerSkills componentData={careerSkillsComponent} />
      {/* Course Duration */}
      <ProgramDuration />
      {/* Why Choose Travel & Tourism Management at JRIIT? */}
      <ProgramBenefits
        programName="Travel & Tourism Management"
        benefits={TRAVEL_TOURISM_BENEFITS}
        careerPaths={TRAVEL_TOURISM_CAREER_PATHS}
      />
      {/* Admission Requirements Section - Always render with defaults if no CMS data */}
      <TravelTourismManagementAdmissionRequirements componentData={admissionRequirementsComponent} />
      {/* Student Acceptance Form */}
      <StudentAcceptanceForm programName="Travel & Tourism Management" />
      <FullScreenImage />
      </div>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default TravelTourismManagement;
